// removed by extract-text-webpack-plugin
module.exports = {"loginForm":"_2ziQYbRQM9MmuDe89jg_wo","headerForm":"_2m-AYxJpZW9WJRzswqnYf9"};